export default [
  {
    name: 'auth.signin',
    path: '/signin',
    component: () => import('@/views/auth/SignIn'),
    meta: {
      title: 'auth.title'
    }
  }
]
